import React from 'react'
import AccessoriesBanner from './AccessoriesBanner'
import { BoardsAccessories, InstallationAccessories } from './AccessoriesProduct'
import { boardsAccessories, installationAccessories } from './AccessoriesData'
import { Link } from 'react-router-dom'
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { stepUp, stepBack } from '../../../Redux/Slice/stepSlice';


const Accessories = () => {

  const dispatch = useDispatch()
  const steps = useSelector((state) => state.step.value)

  return (
    <div>
      <AccessoriesBanner />
      <div>
        <div className="py-2 ">
          <div className="container">
            <div className="">
              <div className="">
                <div className="mb-5">
                  <div className="d-flex">
                    <div className="bitmap-container">
                      <img src="/assets/images/Bitmap(2).png" alt="" className="bitmap img-fluid" />
                    </div>
                  </div>
                  <div className="accessoires-lames mt-4">
                    <span className="text-2">
                      ACCESSOIRES POUR LES LAMES DE TERRACES
                    </span>
                  </div>
                </div>
              </div>
              <div className="row " style={{ marginRight: 260 }}>
                {boardsAccessories.map((product, index) => (
                  <BoardsAccessories key={index} product={product} />
                ))}
              </div>
              <div className="">
                <div className="my-5">
                  <div className="systeme-fixation">
                    <span className="text-2 ">ACCESSOIRES DE POSE</span>
                  </div>
                </div>
                {/* <p class="mb-4">Pour un chantier à moins de 5km des côtes choisissez nos vis inox marin A4</p> */}
              </div>
              <div className="row " style={{ marginRight: 260 }} >
                {installationAccessories.map((product, index) => (
                  <InstallationAccessories key={index} product={product} />
                ))}
              </div>
              <div className="mt-5">
                <div className="">
                  <div className="d-flex justify-content-center">
                    <div className="">
                      <div className="bois-de-pays me-2">
                        <span className="text-2 span">
                          <Link to="/fixture" className='d-flex  align-items-center' onClick={()=> dispatch(stepBack())}>
                            <FaLongArrowAltLeft className='me-3' /> MODIFIEZ
                          </Link>
                        </span>
                      </div>
                    </div>
                    <div className="">
                      <div className="btn btn-secondary box-green rounded-0">
                        <span className="text-2">
                          <Link to="/finalization" className="d-flex align-items-center ps-4" onClick={()=> dispatch(stepUp())}>
                            SUIVANT <FaLongArrowAltRight className='ms-2'/>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex pt-5">
                <div className="m-auto">
                  <nav aria-label="...">
                    <ul className="pagination pagination-sm rounded-0">
                      <li className="page-item">
                        <Link className="page-link rounded-0" to="#">
                          1
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link rounded-0 " to="#">
                          2
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link rounded-0 " to="#">
                          3
                        </Link>
                      </li>
                      <li className="page-item active  rounded-0" aria-current="page">
                        <span className="page-link  rounded-0">4</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Accessories